import React from 'react';
import { connect } from 'react-redux';
import { Grid, GridColumn, GridRow } from 'semantic-ui-react';

import { AppState } from 'services/types';
import Bold from 'components/Bold';
import { createStructuredSelector } from 'reselect';
import { WorksheetPageIndex, WorksheetDate } from 'services/worksheet/types';
import {
    makeSelectFertilizerWorksheetOperatorFullName,
    makeSelectFormattedFertilizerWorksheetDate,
    makeSelectFertilizerWorksheetEntities,
    makeSelectFertilizerWorksheetApplicationMethod
} from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
}

interface ConnectedProps {
    date: WorksheetDate;
    operatorFullName: string | undefined;
    entities: string;
    applicationMethod: string;
}

type Props = OwnProps & ConnectedProps;

export class FertilizerPrintWorksheetHeaderComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { date, operatorFullName, entities, applicationMethod } =
            this.props;

        return (
            <Grid columns="2" className="print-worksheet-header">
                <GridRow className="print-worksheet-header-title">
                    <GridColumn>
                        <h3 className="title">
                            Fertilizer Applicator Worksheet
                        </h3>
                    </GridColumn>
                    <GridColumn textAlign="right">
                        <span className="organisation">T&G Global</span>
                    </GridColumn>
                </GridRow>
                <GridRow className="print-worksheet-header-content">
                    <GridColumn>
                        <Bold>Applicator:</Bold> <span>{operatorFullName}</span>
                    </GridColumn>
                    <GridColumn textAlign="right">
                        <Bold>Handling Precautions:</Bold>{' '}
                        <span>
                            Follow the safety data sheet for each fertilizer
                        </span>
                    </GridColumn>
                </GridRow>
                <GridRow className="print-worksheet-header-content">
                    <GridColumn>
                        <Bold>Orchards:</Bold> <span>{entities}</span>
                    </GridColumn>
                    <GridColumn textAlign="right">
                        <Bold>Date:</Bold> <span>{date}</span>
                    </GridColumn>
                </GridRow>
                <GridRow className="print-worksheet-header-content">
                    <GridColumn width="16">
                        <Bold>Application method:</Bold>{' '}
                        <span>{applicationMethod}</span>
                    </GridColumn>
                </GridRow>
            </Grid>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    date: makeSelectFormattedFertilizerWorksheetDate(),
    operatorFullName: makeSelectFertilizerWorksheetOperatorFullName(),
    entities: makeSelectFertilizerWorksheetEntities(),
    applicationMethod: makeSelectFertilizerWorksheetApplicationMethod()
});

export default connect(mapStateToProps)(
    FertilizerPrintWorksheetHeaderComponent
);
